import { FC } from 'react';
import { MonitoringDateRange } from '../../monitoring/DateRange-Dropdown-util';
import { formatBytes } from '../../../utils/math-utils';
import { X_AXIS_LABEL } from '../../monitoring/GraphContainer';
import { interval } from '../../../feature/feature-services/feature-service/component/ChartDefaultParams';

// generated
import { FCOFields, FeatureViewFCO } from '../../../core/types/fcoTypes';
import PrometheusMonitoring from '@tecton/ComponentRedesign/Charts/PrometheusMonitoring';
import { filterDataForTableViewsOnly } from './utils';

interface DynamoDBP99ResponseSizeProps {
  featureViews: FeatureViewFCO[];
  graphType: number;
  monitoringDateRange: MonitoringDateRange;
}

const DynamoDBP99ResponseSize: FC<DynamoDBP99ResponseSizeProps> = ({
  monitoringDateRange,
  featureViews,
  graphType,
}) => {
  const chartTitle = '';
  const yAxisLabel = 'Bytes';

  const query = `histogram_quantile(0.${graphType}, sum(rate(dynamodb_query_latency_seconds_bucket_rollup_no_pod{ aws_region=~'.*', tecton_cluster=~'.*'}[${interval}])) by(le, table))`;

  const yTicksCallback = (value: any) => {
    const y = formatBytes(value, 0);
    return `${y}`;
  };

  const toolTipLabelCallback = (context: any) => {
    const { y } = context.parsed;
    const { label } = context.dataset;
    const value = formatBytes(y, 0);

    const labelText = `${label}: ${value}`;
    return labelText;
  };

  const getMetricLabelCallback = (result: any, label?: string) => {
    // Matches the Feature View ID (which is in the dataset)
    // to the Feature View Name (which is in FeatureViews)
    // Ensures that charts render properly

    const id = result.metric.table.split('_').pop();
    const matchingFeatureView = featureViews.find((fv) => {
      return fv.id == id;
    });

    return `P${graphType}:${matchingFeatureView?.[FCOFields.NAME] ?? ''}`;
  };

  const yOverride = {
    title: {
      display: true,
      text: yAxisLabel,
      font: {
        size: 12,
      },
    },
    min: 0,

    ticks: {
      callback: yTicksCallback,
    },
  };

  return (
    <>
      <PrometheusMonitoring
        chartTitle={chartTitle}
        monitoringDateRange={monitoringDateRange}
        queries={[{ label: `P${graphType}`, query: query }]}
        xAxisLabel={X_AXIS_LABEL}
        yAxisLabel={yAxisLabel}
        yTicksCallback={yTicksCallback}
        yGrace={0}
        toolTipLabelCallback={toolTipLabelCallback}
        yOverride={yOverride}
        parseValue={parseFloat}
        getMetricLabelCallback={getMetricLabelCallback}
        height={160}
        transformData={(data) => {
          return filterDataForTableViewsOnly(data, featureViews);
        }}
      />
    </>
  );
};

export default DynamoDBP99ResponseSize;
